import { Quote } from "lucide-react";
import { FadeUp, LineReveal } from "@/components/site/Reveal";
import { TESTIMONIALS } from "@/lib/content2";

const Card = ({ t, i }) => (
  <FadeUp delay={i * 0.1} data-testid={`testimonial-${t.id}`} className={`relative rounded-2xl p-8 lg:p-12 flex flex-col ${i ? "bg-[var(--surface)] border border-white/10" : "bg-white text-[var(--ink)]"}`}>
    <Quote size={44} className={i ? "text-[var(--sun)]" : "text-[#0057c2]"} />
    <p className="mt-6 font-display font-black uppercase text-3xl sm:text-4xl leading-[0.95]">“{t.pull}”</p>
    <p className={`mt-6 leading-relaxed ${i ? "text-slate-300" : "text-slate-700"}`}>{t.quote}</p>
    <div className={`mt-8 grid gap-3 ${t.stats.length > 2 ? "grid-cols-3" : "grid-cols-2"}`}>
      {t.stats.map(([v, l]) => (
        <div key={l} className={`rounded-xl p-4 ${i ? "bg-[var(--ink)]" : "bg-[var(--concrete)]"}`}>
          <p className="font-display font-black text-2xl sm:text-3xl">{v}</p>
          <p className={`text-xs mt-1 ${i ? "text-slate-400" : "text-slate-600"}`}>{l}</p>
        </div>
      ))}
    </div>
    <div className={`mt-auto pt-8 border-t ${i ? "border-white/10" : "border-black/10"} mt-8`}>
      <p className={`font-mono text-[11px] tracking-[0.2em] uppercase ${i ? "text-[var(--sun)]" : "text-[#0057c2]"}`}>{t.tag}</p>
      <p className="mt-1 font-display font-black uppercase text-2xl">{t.name}</p>
      <p className={`text-sm ${i ? "text-slate-400" : "text-slate-600"}`}>{t.org}</p>
    </div>
  </FadeUp>
);

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="bg-[var(--ink)]">
    <div className="mx-auto max-w-[1440px] px-5 lg:px-10 py-24 lg:py-36">
      <p className="eyebrow">In their words</p>
      <LineReveal onView lines={["Trusted by owners", "who run the numbers."]} className="mt-5 font-display font-black uppercase leading-[0.88] text-5xl sm:text-6xl lg:text-7xl" />
      <div className="mt-14 grid lg:grid-cols-2 gap-4 items-stretch">
        {TESTIMONIALS.map((t, i) => <Card key={t.id} t={t} i={i} />)}
      </div>
    </div>
  </section>
);
